import { Col, Row } from "reactstrap";
import { Href, ImageTextTitle, SidebarIconTitle } from "../../../../Constants/Constants";
import { SidebarIconData } from "../../../../Data/Bonus/Elements";
import { dynamicImage, Image } from "../../../../Utils";
import SvgIcon from "../../../CommonComponents/SvgIcon";
import MainChat from "./MainChat";

const SidebarIcon = () => {
  return (
    <section className="Icons">
      <Row>
        <Col xxl="4" lg="6" sm="12">
          <div className="element-card bg-primary">
            <div className="element-card-header heading"><h2 className="font-light">{SidebarIconTitle}</h2></div>
            <div className="element-card-body typography px-0">
              <div className="fonts mb-0">
                {SidebarIconData.map((item, index) => (
                  <a className="header-icon button-effect" href={Href} title={item} key={index}>
                    <SvgIcon iconId={item} className="header-stroke-icon" />
                    <SvgIcon iconId={item} className="header-fill-icon" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </Col>
        <Col xxl="4" lg="6" sm="12">
          <div className="element-card">
            <div className="element-card-header heading"><h2>{ImageTextTitle}</h2></div>
            <div className="element-card-body typography">
              <ul className="img-text">
                <li>
                  <div className="chat-box">
                    <div className="profile"><Image className="bg-img img-fluid" src={dynamicImage("avtar/1.jpg")} alt="Avatar" /></div>
                    <div className="details">
                      <h2>{"Josephin water"}</h2>
                      <h4>{"Hi, i am josephin. How are you.. ! There are many variations of passages. "}</h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Col>
        <MainChat />
      </Row>
    </section>
  );
};

export default SidebarIcon;
